const translateMap = (value, map) => {
  const targets = Object.keys(map)
    .join('|')
    .replace('\\', '\\\\')
  const regex = new RegExp(`(${targets})`, 'g')

  return String(value).replace(regex, char => map[char])
}

const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#x27;',
}

export const escapeHtml = value => translateMap(value, HTML_ESCAPES)

export const normalizeNewlines = value => value.replace(/\r\n|\r/g, '\n')
